
import React, { useEffect, useState } from 'react';

import { Button, Card, Col, Dropdown, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';

import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';

import { useNavigate } from 'react-router-dom';
import { fileUpload } from 'functions/fileUpload';
import { toastMessageBox } from 'components/ToastifyMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArchive, faTimes } from '@fortawesome/free-solid-svg-icons';


const FileUpload=({setAttachmentHandler})=>{
   
    
    const [attachments, setAttachments] = useState([
        // { id: 1, name: 'winter.jpg', size: 893952, type: 'image/jpg',fileNo:1,file:null },
        // { id: 2, name: 'coffee.zip', size: 350208, type: 'application/zip',fileNo:2,file:null }
      ]);

      const [isFileUploading,setIsFileUploading]=useState(false);


useEffect(() => {
  setAttachmentHandler(attachments);
}, [attachments]);

    
      const uploadFile=(file)=>{
        console.log('uploadFile ',file)
      return  new Promise(async (resolve,reject)=>{
        const formData = new FormData();
        formData.append('file', file);
        const { name, size, type } = file;
       fileUpload(`${name}, ${size}, ${type}`, '5:30', 1,name, formData)
         .then(res => {
           resolve({ res, file });
         })
         .catch(err => {
           reject(err);
         });
      })
      }
      
      const handleAddAttachment =async files => {
        if (files.length === 0) return;
        console.log('files',files);
        //const file=files[0];
    
        const fileArray = [];
    
        Array.from(files).forEach(async file => {
          setIsFileUploading(true);
          const res=await uploadFile(file);
          const { name, size, type } = res.file;
          const {fileNo} = res.res.data;
          console.log('res.res.data',res.res.data)
          if(res.res.data.error){
            toastMessageBox("Exception",`Selected file ${name} is too large`,"warning");
            setIsFileUploading(false);
            return;
          }
       const newFile = {
         id: name + 1 + Date.now(),
         name,
         size,
         type,
         file,
         fileNo:fileNo
       };
       fileArray.push(newFile);
       setAttachments([...attachments, ...fileArray]);
       console.log('res',res);
       setIsFileUploading(false);
        });
    
    
        console.log('fileArray',fileArray);
      };
    
    
    
      const handleDetachAttachment = id => {
        setAttachments(attachments.filter(attachment => attachment.id !== id));
      };
      
    return(
        <>

<div className='mt-4' style={{}}>
<Flex>
             {isFileUploading ? (
               <Flex>
               <Spinner animation="border" size="sm" />
               <p style={{marginLeft:'5px'}}> Please wait....</p>
               </Flex>

             ) : (
               <>
                 <Form.Group controlId="email-attachment">
                   <Form.Control
                     type="file"
                     multiple
                     className="d-none"
                     onChange={({ target }) =>
                       handleAddAttachment(target.files)
                     }
                   />
                   <OverlayTrigger
                     overlay={
                       <Tooltip
                         style={{ position: 'fixed' }}
                         id="previousTooltip"
                       >
                         Attach files
                       </Tooltip>
                     }
                   >
                     <div>
                       <IconButton
                         as={Form.Label}
                         className="me-2 mb-0"
                         variant="light"
                         size="sm"
                         icon="paperclip"
                         iconClassName="fs-1"
                         transform="down-2"
                       />
                     </div>
                   </OverlayTrigger>
                 </Form.Group>
                 <Form.Group controlId="email-image">
                   <Form.Control
                     type="file"
                     className="d-none"
                     accept="image/*"
                     multiple
                     onChange={({ target }) =>
                       handleAddAttachment(target.files)
                     }
                   />
                   <OverlayTrigger
                     overlay={
                       <Tooltip
                         style={{ position: 'fixed' }}
                         id="previousTooltip"
                       >
                         Attach images
                       </Tooltip>
                     }
                   >
                     <div>
                       <IconButton
                         as={Form.Label}
                         className="me-2 mb-0"
                         variant="light"
                         size="sm"
                         icon="image"
                         iconClassName="fs-1"
                         transform="down-2"
                       />
                     </div>
                   </OverlayTrigger>
                 </Form.Group>
               </>
             )}
           </Flex>
           </div>
         <div style={{display:'flex',flexWrap:'wrap'}}>
 
  {attachments.map((attachment) => (
    <div key={attachment.id} style={{ padding: '10px', backgroundColor: '#e9ecef', borderRadius: '10px', margin: '10px' }} className="attachment-item">
    {/* Generic file icon for all types of attachments */}
    <span className="file-icon me-2">
      {/* You can replace this with an actual icon */}
      <FontAwesomeIcon icon="" />
    </span>
  
    <OverlayTrigger
      key={attachment.id}
      placement="top"
      overlay={<Tooltip id={`tooltip-${attachment.id}`}>{attachment.name}</Tooltip>}
    >
      <span className="file-name me-2" style={{ maxWidth: "1200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "13px" }}>
        {attachment.name.substring(0, 20) + (attachment.name.length > 20 ? "..." : "")}
      </span>
    </OverlayTrigger>
  
    {/* Button to remove the attachment */}
    <IconButton
      variant="outline-danger"
      size="sm"
      style={{ margin: '1px', fontSize: '12px', height: '20px', padding: '2px', border: 'none' }} // Updated height to 20px
      icon={faTimes}
      onClick={() => handleDetachAttachment(attachment.id)}
    >
      
    </IconButton>
  </div>
  
  ))}




         
         </div>
        </>
    )
}

export default FileUpload;